import { ChevronDown } from "lucide-react"

interface AskDynamoJumpToLatestButtonProps {
  visible: boolean
  onClick: () => void
}

export function AskDynamoJumpToLatestButton({ visible, onClick }: AskDynamoJumpToLatestButtonProps) {
  if (!visible) return null

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Jump to latest message"
      className="absolute bottom-2 left-1/2 z-10 inline-flex h-9 w-9 -translate-x-1/2 items-center justify-center rounded-full bg-[var(--color-ask-dynamo)] text-white shadow-sm transition hover:opacity-90"
    >
      <ChevronDown size={18} aria-hidden />
    </button>
  )
}
